import { Order } from '../../helpers/Order';
import { IOrderClause } from '../../ServerApi/types/IOrderClause';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

interface DatasourceSubspaceSortOptions {
  defaultOrder: IOrderClause[];
  options: OptionsDictionary;
}

export const DatasourceSubspaceConnectionsSortOptions: DatasourceSubspaceSortOptions = {
  defaultOrder: [Order.asc(OrderKeys.connectionTypeDisplayName)],
  options: {
    'type': SortOptions.connectionType
  }
};
